import { render, staticRenderFns } from "./TrainingDataAnalysisCaiJiTrend.vue?vue&type=template&id=5986171c&scoped=true&"
import script from "./TrainingDataAnalysisCaiJiTrend.vue?vue&type=script&lang=js&"
export * from "./TrainingDataAnalysisCaiJiTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5986171c",
  null
  
)

export default component.exports